<div class="support-heading">
    <div>
        <h2 id="pulse-support-title">Contact Pulse support</h2>
        <p>Tell us what happened so we can help.</p>
    </div>
    <button
        type="button"
        class="support-close"
        aria-label="Close support"
        [disabled]="sending || reading || capturing"
        (click)="activeModal.close()">
        ×
    </button>
</div>
@if (result) {
    <div class="support-confirmation" role="status" aria-live="polite">
        <i class="la la-check-circle" aria-hidden="true"></i>
        <h3>Ticket #{{ result.ticket_id }} created</h3>
        @if (result.routing_verified === false) {
            <p class="support-warning">
                Your ticket was created, but its support team assignment needs checking. Contact your Pulse
                administrator with this ticket number.
            </p>
        } @else {
            <p>Your request has been sent. Our support team will reply to {{ requester }}.</p>
        }
        @if (result.ticket_url) {
            <p>
                <a [href]="result.ticket_url" target="_blank" rel="noopener noreferrer">View ticket in Freshservice</a>
            </p>
        }
        @if (!result.context_saved) {
            <p class="support-warning">
                Your ticket was created, but its page details could not be added. You can retry adding them below.
            </p>
        }
    </div>
} @else {
    <form id="pulse-support-form" #supportForm="ngForm" (ngSubmit)="submit()" class="support-form">
        <label for="support-requester">Reply email</label>
        <input id="support-requester" type="email" [value]="requester" readonly />
        <label for="support-subject">Subject</label>
        <input
            id="support-subject"
            name="subject"
            [(ngModel)]="subject"
            required
            maxlength="200"
            placeholder="What do you need help with?"
            [disabled]="!!payload || sending || capturing"
            ngbAutofocus />
        <label for="support-description">What happened?</label>
        <textarea
            id="support-description"
            name="description"
            [(ngModel)]="description"
            required
            maxlength="10000"
            rows="6"
            placeholder="Describe what you were doing, what you expected, and what happened instead."
            [disabled]="!!payload || sending || capturing"></textarea>
        <label for="support-screenshot">Screenshot <span>(optional)</span></label>
        @if (screenshotAvailable) {
            <div class="support-capture-actions">
                <button
                    type="button"
                    class="support-secondary"
                    (click)="captureScreenshot()"
                    [disabled]="!!payload || sending || reading || capturing">
                    {{ capturing ? 'Capturing…' : pageScreenshot ? 'Retake screenshot' : 'Capture screenshot' }}
                </button>
                @if (pageScreenshot) {
                    <button
                        type="button"
                        class="support-secondary"
                        (click)="removeCapture()"
                        [disabled]="!!payload || sending || capturing">
                        Remove
                    </button>
                }
            </div>
            <p class="support-hint">
                Choose this Pulse tab in your browser's sharing window. The support form is hidden while the screenshot
                is taken.
            </p>
        }
        @if (pageScreenshot) {
            <img
                class="support-capture-preview"
                [src]="'data:' + pageScreenshot.mime + ';base64,' + pageScreenshot.base64"
                alt="Captured screen preview" />
            <p class="support-hint">Your captured screenshot is attached. You can add another below.</p>
        }
        <input
            id="support-screenshot"
            type="file"
            accept="image/png,image/jpeg,image/webp"
            (change)="chooseScreenshot($event)"
            [disabled]="!!payload || sending || reading || capturing"
            aria-describedby="support-file-help" />
        <p id="support-file-help" class="support-hint">
            PNG, JPEG or WebP, up to 5 MB. {{ reading ? 'Reading screenshot…' : fileName }}
        </p>
        <p class="support-context-hint">
            Page and selection details are included automatically to help us investigate.
        </p>
    </form>
}
@if (error) {
    <p class="support-error" role="alert">{{ error }}</p>
}
<div class="support-footer">
    <button
        type="button"
        class="support-secondary"
        [disabled]="sending || reading || capturing"
        (click)="activeModal.close()">
        {{ result ? 'Close' : 'Cancel' }}
    </button>
    @if (!enabled && !checking) {
        <button type="button" class="support-primary" (click)="checkConfiguration()">Retry connection</button>
    } @else if (!result?.context_saved) {
        <button
            type="button"
            class="support-primary"
            [disabled]="
                checking ||
                sending ||
                reading ||
                capturing ||
                !enabled ||
                (!payload && (!subject.trim() || !description.trim()))
            "
            (click)="submit()">
            {{
                checking
                    ? 'Connecting…'
                    : sending
                      ? 'Sending…'
                      : result
                        ? 'Retry page details'
                        : payload
                          ? 'Retry request'
                          : 'Send request'
            }}
        </button>
    }
</div>
